import ToolBox from '../ToolBox';
import Template from "ui/Template";
import {i18n} from "ui/i18n";
import {EVENT_CHANGE_TOOL} from "ui/canvas/Canvas";
import toolsView from './tools.handlebars';

/**
 * Tools switcher element
 */
class Tools extends ToolBox {
	/**
	 * Class constructor
	 *
	 * @param {Object} [options]
	 */
	constructor(options = {}) {
		super(Object.assign({
			title: i18n('title.tools')
		}, options));

		if (options.body) {
			this.setBodyElement(options.body);
		} else {
			this.setBodyElement(
				new Template(toolsView)
					.createElement()
			);
		}

		/**
		 * @type {Element}
		 * @protected
		 */
		this._selectedToolButton = null;

		/**
		 * @type {Map<string, boolean>}
		 * @private
		 */
		this._flags = new Map();

		this.scene.canvas.events.addListener(EVENT_CHANGE_TOOL, () => {
			this.updateSelectedTool();
		});

		this.body.querySelectorAll('.editor-tools__button').forEach((el) => {
			el.addEventListener('click', () => {
				this.selectTool(el.getAttribute('data-tool'));
			})
		});

		this.body.querySelectorAll('.editor-tools__switch').forEach((el) => {
			let name = el.getAttribute('data-name');
			this._flags.set(name, false);
			el.addEventListener('click', () => {
				this.setFlag(name, !this.getFlag(name));
			})
		});

		this.updateSelectedTool();
	}
	
	/**
	 * Returns selected tool value
	 *
	 * @returns {string}
	 */
	getSelectedTool() {
		return this.scene.canvas.getTool();
	}

	/**
	 * Sets current tool
	 *
	 * @param {string} name
	 * @returns {void}
	 */
	selectTool(name) {
		this.scene.canvas.setTool(name);
		this.updateSelectedTool();
	}

	/**
	 * Presses button for currently selected tool
	 *
	 * @returns {Tools}
	 */
	updateSelectedTool() {
		if (this._selectedToolButton) {
			this._selectedToolButton.classList.remove('editor-tools__button_selected');
			this._selectedToolButton = null;
		}
		let el = this.body.querySelector(`.editor-tools__button[data-tool="${this.getSelectedTool()}"]`);
		if (el) {
			this._selectedToolButton = el;
			el.classList.add('editor-tools__button_selected');
		}
		return this;
	}

	/**
	 * Updates all flags states
	 *
	 * @returns {Tools}
	 */
	updateFlags() {
		for (let [name, isChecked] of this._flags.entries()) {
			if (this.getFlag(name) !== isChecked) {
				this.setFlag(name, !isChecked);
			}
		}
		return this;
	}

	/**
	 * Sets flag value
	 *
	 * @param {string} name
	 * @param {boolean} isChecked
	 * @returns {Tools}
	 */
	setFlag(name, isChecked) {
		this._flags.set(name, isChecked);
		let el = this.body.querySelector(`.editor-tools__switch[data-name="${name}"]`);
		if (el) {
			el.classList.toggle('editor-tools__switch_checked', isChecked);
		}
		return this;
	}

	/**
	 * Returns flag value
	 *
	 * @param {string} name
	 * @returns {boolean}
	 */
	getFlag(name) {
		return !!this._flags.get(name);
	}
}

export default Tools;
